'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'tower-observation';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e586';
var svgPathData = 'M216.8 1.7c4.5-2.3 9.8-2.3 14.3 0l176 88c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-8.8-4.4 0 78.1c0 26.5-21.5 48-48 48l-7.8 0 39.6 237.4c.1 .9 .2 1.8 .2 2.6l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c0-.9 .1-1.7 .2-2.6l39.6-237.4-7.8 0c-26.5 0-48-21.5-48-48l0-78.1-8.8 4.4c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l176-88zM224 33.9l-128 64 0 30.1 256 0 0-30.1-128-64zM96 160l0 32c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-32-256 0zM327.4 480L224 391.4 120.6 480 327.4 480zM152 240c0 .9-.1 1.7-.2 2.6l-6.5 39.1 78.7 67.5 78.7-67.5-6.5-39.1c-.1-.9-.2-1.8-.2-2.6l-144 0zm-12.9 78.6l-20.1 120.6 80.4-68.9-60.3-51.7zm109.5 51.7l80.4 68.9-20.1-120.6-60.3 51.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTowerObservation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;